<template>
  <div :style="logoStyle"></div>
</template>

<script>
export default {
  computed: {
    logoStyle: function () {
      let logoConfig = this.$store.state.malMainPageConfig.logo.imgUrl;
      return {
        backgroundImage: "url(" + logoConfig + ")",
        backgroundRepeat: "no-repeat",
        height: "64px",
        width: "240px",
      };
    },
  },
};
</script>

<style scoped lang="scss">
</style>
